import React from 'react';
import { HeadCard } from '../../structure/card/HeadCard';
import { DatatableTipoMembresias } from './DatatableTipoMembresias';

export const TipoMembresiasPage = () => {
    return (
        <div className="content-wrapper">
            <HeadCard titulo="Configuración de Planes" />
            <section className="content">
                <div className="card">
                    <div className="card-header">
                    </div>
                    <DatatableTipoMembresias />
                </div>
            </section>
        </div>
    );
};
